import { isEqual } from 'lodash';
import { durationAsMonths } from '../utils/dateUtils';

export const SEC_IN_MINUTE = 60;
export const SEC_IN_HOUR = SEC_IN_MINUTE * 60;
export const SEC_IN_DAY = SEC_IN_HOUR * 24;

export default class Utils {
    static isValidDate(date) {
        // eslint-disable-next-line no-restricted-globals
        return !isNaN(new Date(date).getTime());
    }

    static getClassName(classNames) {
        return (classNames || []).reduce((result, className) => {
            if (!className) {
                return result;
            }

            if (result.length === 0) {
                return className;
            }

            return `${result} ${className}`;
        }, '');
    }

    static getIndexOf(a, b) {
        return (a || '').toLowerCase().indexOf((b || '').toLowerCase());
    }

    static toLowerCaseSafe = (string) => (string || '').toLowerCase();

    static capitalizeSafe = (string) => {
        if (typeof string !== 'string') {
            return '';
        }

        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    static joinTokens(tokens, delimiter) {
        return (tokens || []).reduce((result, currentItem) => {
            if (!result && currentItem) {
                return currentItem;
            }

            if (currentItem) {
                return `${result}${delimiter}${currentItem}`;
            }

            return result;
        }, '');
    }

    static getEmailDomain(email) {
        const domainRegex = /^[\w+.\w+]*@(\w+\.[\w+.]*)$/g;
        const match = domainRegex.exec(email);

        return match && match[1];
    }

    static getRandomNumber(min = 0, max = 1) {
        return Math.floor((Math.random() * (max - min)) + min);
    }

    static getRandomNumbersArray(min, max, length, acc = []) {
        if (length === 0) {
            return acc;
        }

        let found = false;

        do {
            const random = Utils.getRandomNumber(min, max);
            if (!acc.includes(random)) {
                acc.push(random);
                found = true;
            }
        } while (!found);

        return Utils.getRandomNumbersArray(min, max, length - 1, acc);
    }

    static RoundNumber(num, fractionSize) {
        if (typeof num !== 'number') {
            return 0;
        }

        return Math.round(num * (10 ** fractionSize)) / (10 ** fractionSize);
    }

    static cancellablePromiseWrapper(asyncFunc) {
        return (...args) => {
            let isCancelled = false;

            const cancellablePromise = new Promise((res, rej) => {
                const asyncFuncPromise = asyncFunc(...args);

                asyncFuncPromise.then((...resultData) => {
                    if (isCancelled) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        rej({ reason: 'cancelled' });
                        isCancelled = false;
                    } else {
                        res(...resultData);
                    }
                }).catch(rej);
            });

            cancellablePromise.cancel = () => {
                isCancelled = true;
            };

            return cancellablePromise;
        };
    }

    static delay(ms) {
        // eslint-disable-next-line no-promise-executor-return
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    static escapeRegExp(s) {
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    static setIfStateChanged(prevState, newState) {
        const isStateNew = !isEqual(prevState, newState);

        if (isStateNew) {
            return newState;
        }

        return prevState;
    }

    static getEmploymentDuration(dateStartSource, dateEndSource) {
        const dateStart = dateStartSource ? new Date(dateStartSource) : null;
        if (!dateStart) {
            return 0;
        }
        try {
            const dateEnd = dateEndSource ? new Date(dateEndSource) : new Date();
            const durationMonths = durationAsMonths(dateStart, dateEnd);
            return Math.round((durationMonths + Number.EPSILON) * 10) / 10;
        } catch (err) {
            return 0;
        }
    }

    static parseJSON(string) {
        try {
            return JSON.parse(string);
        } catch (error) {
            return null;
        }
    }
}
